/**
 * Dev-only logger utility.
 *
 * All output is suppressed in production builds (`import.meta.env.PROD`).
 * Use this instead of `console.log` throughout the frontend.
 *
 * IMPORTANT: Never pass PII (names, FEINs, tokens, employee data, full API
 * responses) to any logger method — even in dev mode.  Log operational flow
 * messages only (e.g. "Polling started", "Modal opened").
 */

const isDev = !import.meta.env.PROD;

/* eslint-disable no-console */
const noop = (..._args: unknown[]) => {};

const logger = {
  /** General informational messages (dev only). */
  debug: isDev ? console.debug.bind(console) : noop,

  /** Operational flow messages (dev only). */
  info: isDev ? console.info.bind(console) : noop,

  /** Warnings worth investigating (dev only). */
  warn: isDev ? console.warn.bind(console) : noop,

  /**
   * Errors — always emitted so production issues are visible in browser
   * dev-tools when troubleshooting.  Still: NEVER include PII.
   */
  error: console.error.bind(console),
} as const;
/* eslint-enable no-console */

export default logger;
